module.exports = __webpack_public_path__ + "img/check-icon-white.a56ca065.svg";